import React from 'react';
import { uuid } from 'rt-sd-common/sgiCommon/sgiCommon';
import { Calendar, Badge, Alert } from 'antd';
import moment from 'moment';
import { addCtnCommonAttribute } from './SgiCtnComm';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { SgiEventHandler } from './SgiEventHandler';

// 注意：Calendar 部分 locale 是从 value 中读取，所以请先正确设置 moment 的 locale。
// 默认语言为 en-US，所以如果需要使用其他语言，推荐在入口文件全局设置 locale
// import moment from 'moment';
// import 'moment/locale/zh-cn';
// moment.locale('zh-cn');


class SgiCalendar extends React.Component {

    //这个暂时不好用 以后在处理
    static defaultProps = {
    };  // 注意这里有分号
    static propTypes = {
    };  // 注意这里有分号

    constructor(props) {
        super(props);
        this.state = {
            //ctnProps: { style: {} },//form属性
            calendarProps: { style: { heigth: '100%', width: '100%' } },//calendar全局属性
            loading: false,
            toolbarTopItems: [],
            toolbarBottomItems: [],
            calendarUUID: undefined,

            functions: {},//存放functions

            value: moment(),
        };
    }

    /**
     * 根据描述创建form
     * @param {父组件} parentModule 
     * @param {描述} moduleDesc       
     * @param {对象工厂} objFct 
     * @param {make类型} type 
     */
    calendar_mk(parentModule, moduleDesc, objFct, type) {
        //获取需要展示的数据信息
        if (!moduleDesc) {
            return;
        }

        this.state.calendarItems = []; //再次渲染的时候清空

        //转换form公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.calendarProps);
        //转换基础属性
        this.AddAttribute(moduleDesc, this.state.calendarProps, this.state.functions, parentModule, type);
        //设置布局
        //this.setFormCtlLayout(moduleDesc, formProps);
        //绑定事件
        this.bindEvent(moduleDesc, this.state.calendarProps, this.state.functions);
        //组装form表单下的控件信息
        // this.fitCalendarItems(moduleDesc, this.state.calendarItems, objFct, type);
    }

    /**
     * 属性转换
     * @param {object} moduleDesc 属性描述
     * @param {object} calendarProps 组件属性
     * @param {object} parentModule 父组件
     * @param {object} type 类型
     */
    AddAttribute = function (moduleDesc, calendarProps, functions, parentModule, type) {

        // 显示模式，月/年
        calendarProps.mode = moduleDesc.mode;

        // 全屏显示
        calendarProps.fullscreen = !!moduleDesc.isFllScrn;

        // 开发模式不走以下渲染事件
        if (this.props.type === "dnd") return;

        // 自定义日期渲染--追加渲染
        var dtCllRndr = moduleDesc.dtCllRndr;
        if (dtCllRndr) {
            var $dtCllRndr;
            try {
                $dtCllRndr = new Function("module", "objFct", 'value', 'moment', dtCllRndr);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.dateCellRender = $dtCllRndr;
        }

        // 自定义日期渲染--完全渲染
        var dtFllCllRndr = moduleDesc.dtFllCllRndr;
        if (dtFllCllRndr) {
            var $dtFllCllRndr;
            try {
                $dtFllCllRndr = new Function("module", "objFct", 'value', 'moment', dtFllCllRndr);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.dateFullCellRender = $dtFllCllRndr;
        }

        // 自定义月份渲染--追加渲染
        var mnthCllRndr = moduleDesc.mnthCllRndr;
        if (mnthCllRndr) {
            var $mnthCllRndr;
            try {
                $mnthCllRndr = new Function("module", "objFct", 'value', 'moment', mnthCllRndr);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.monthCellRender = $mnthCllRndr;
        }

        // 自定义月份渲染--完全渲染
        var mnthFllCllRndr = moduleDesc.mnthFllCllRndr;
        if (mnthFllCllRndr) {
            var $mnthFllCllRndr;
            try {
                $mnthFllCllRndr = new Function("module", "objFct", 'value', 'moment', mnthFllCllRndr);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.monthFullCellRender = $mnthFllCllRndr;
        }

        // 自定义不可选
        var dsbldDt = moduleDesc.dsbldDt;
        if (dsbldDt) {
            var $dsbldDt;
            try {
                $dsbldDt = new Function("module", "objFct", 'value', 'moment', dsbldDt);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.disabledDate = $dsbldDt;
        }

        // dateCellRender	自定义渲染日期单元格，返回内容会被追加到单元格	function(date: moment): ReactNode	无
        // dateFullCellRender	自定义渲染日期单元格，返回内容覆盖单元格	function(date: moment): ReactNode	无
        // defaultValue	默认展示的日期	moment	默认日期
        // disabledDate	不可选择的日期(currentDate: moment) => boolean	无
        // fullscreen	是否全屏显示	boolean	true
        // locale	国际化配置	object	默认配置
        // mode	初始模式，month / year	string	month
        // monthCellRender	自定义渲染月单元格，返回内容会被追加到单元格	function(date: moment): ReactNode	无
        // monthFullCellRender	自定义渲染月单元格，返回内容覆盖单元格	function(date: moment): ReactNode	无
        // validRange	设置可以显示的日期[moment, moment]	无
        // value	展示日期	moment	当前日期
        // onPanelChange	日期面板变化回调	function(date: moment, mode: string)	无
        // onSelect	点击选择日期回调	function(date: moment）	无
        // onChange	日期变化回调	function(date: moment）	无

    }

    /**
     * 绑定事件
     * @param {object} moduleDesc 属性描述
     * @param {object} calendarProps 组件属性
     */
    bindEvent(moduleDesc, calendarProps, functions) {

        // 自定义选择事件
        var slctLsn = moduleDesc.slctLsn;
        if (slctLsn) {
            var $slctLsn;
            try {
                $slctLsn = new Function("module", "objFct", 'value', 'moment', slctLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onSelect = $slctLsn;
        }
        calendarProps.onSelect = SgiEventHandler.calendarOnSelect.bind(this);

        // 自定义面板切换事件
        var pnlChgLsn = moduleDesc.pnlChgLsn;
        if (pnlChgLsn) {
            var $pnlChgLsn;
            try {
                $pnlChgLsn = new Function("module", "objFct", 'value', 'moment', "mode", pnlChgLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onPanelChange = $pnlChgLsn;
        }
        calendarProps.onPanelChange = SgiEventHandler.calendarOnPanelChange.bind(this);

        // 自定义日期变化事件
        var chgLsn = moduleDesc.chgLsn;
        if (chgLsn) {
            var $chgLsn;
            try {
                $chgLsn = new Function("module", "objFct", 'value', 'moment', chgLsn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            functions.onChange = $chgLsn;
        }
        calendarProps.onChange = SgiEventHandler.calendarOnChange.bind(this);

    }

    refresh = () => {
        this.setState({});
    }

    // onPanelChange(value, mode) {
    //     tool.sgiLogger.log('value :', value);
    //     tool.sgiLogger.log('mode :', mode);
    // }

    // getListData(value) {
    //     let listData;
    //     switch (value.date()) {
    //         case 8:
    //             listData = [
    //                 { type: 'warning', content: 'This is warning event.' },
    //                 { type: 'success', content: 'This is usual event.' },
    //             ]; break;
    //         case 10:
    //             listData = [
    //                 { type: 'warning', content: 'This is warning event.' },
    //                 { type: 'success', content: 'This is usual event.' },
    //                 { type: 'error', content: 'This is error event.' },
    //             ]; break;
    //         case 15:
    //             listData = [
    //                 { type: 'warning', content: 'This is warning event' },
    //                 { type: 'success', content: 'This is very long usual event。。....' },
    //                 { type: 'error', content: 'This is error event 1.' },
    //                 { type: 'error', content: 'This is error event 2.' },
    //                 { type: 'error', content: 'This is error event 3.' },
    //                 { type: 'error', content: 'This is error event 4.' },
    //             ]; break;
    //         default:
    //     }
    //     return listData || [];
    // }

    // dateCellRender(value) {
    //     const listData = this.getListData(value);
    //     return (
    //         <ul className="events">
    //             {
    //                 listData.map(item => (
    //                     <li key={item.content}>
    //                         <Badge status={item.type} text={item.content} />
    //                     </li>
    //                 ))
    //             }
    //         </ul>
    //     );
    // }

    // getMonthData(value) {
    //     if (value.month() === 8) {
    //         return 1394;
    //     }
    // }

    // monthCellRender(value) {
    //     const num = this.getMonthData(value);
    //     return num ? (
    //         <div className="notes-month">
    //             <section>{num}</section>
    //             <span>Backlog number</span>
    //         </div>
    //     ) : null;
    // }

    commonCellRender(type, date) {
        if (!type || !date) return;

        const { functions } = this.state;
        if (functions && functions[type]) {
            const { objFct } = this.props;
            const value = date.format("YYYY-MM-DD");
            return functions[type](this, objFct, value, date);
        }
    }
    getCellRender(type) {

        if (this.props.type === "dnd") return;

        const { functions } = this.state;
        if (functions && functions[type]) {
            return this.commonCellRender.bind(this, type);
        }
    }

    getValue(parameters) {
        if (!parameters || (!typeof parameters === "object" || Array.isArray(parameters))) {
            return this.state.value.format("YYYY-MM-DD");
        } else if (parameters.type === "moment") {
            return this.state.value;
        } else if (parameters.format) {
            return this.state.value.format(parameters.format);
        } else {
            return this.state.value.format("YYYY-MM-DD");
        }
    }
    getMoment() {
        return this.state.value;
    }
    setValue(value, parameters) {
        if (parameters && parameters.type === "moment") {
            this.setState({ value });
        } else {
            this.setState({ value: moment(value) });
        }
    }
    setMoment(moment) {
        this.setState({ value: moment });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性
            this.calendar_mk(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        const { value, selectedValue, calendarProps, functions } = this.state;

        return (
            <div>
                <Calendar
                    className="sgiCalendar"
                    {...calendarProps}
                    value={value}
                    disabledDate={this.getCellRender.call(this, "disabledDate")}
                    dateCellRender={this.getCellRender.call(this, "dateCellRender")}//自定义追加渲染事件--日期
                    dateFullCellRender={this.getCellRender.call(this, "dateFullCellRender")}//自定义完全渲染事件--日期
                    monthCellRender={this.getCellRender.call(this, "monthCellRender")}//自定义追加渲染事件--月份
                    monthFullCellRender={this.getCellRender.call(this, "monthFullCellRender")}//自定义完全渲染事件--月份
                />
            </div>
        )
    }

}
//给类添加公共方法
// Object.assign(SgiCalendar.prototype, sgiCtnBaseFun);
export { SgiCalendar };
export default SgiCalendar;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/SgiCalendar.js